module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("Contents")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/newslettersignup"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Newsletter sign-up")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("4. ")]), _c('a', {
    attrs: {
      "href": "#/chapter004"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("5. ")]), _c('a', {
    attrs: {
      "href": "#/chapter005"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("6. ")]), _c('a', {
    attrs: {
      "href": "#/chapter006"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("7. ")]), _c('a', {
    attrs: {
      "href": "#/chapter007"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("8. ")]), _c('a', {
    attrs: {
      "href": "#/chapter008"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("9. ")]), _c('a', {
    attrs: {
      "href": "#/chapter009"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("10. ")]), _c('a', {
    attrs: {
      "href": "#/chapter010"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("11. ")]), _c('a', {
    attrs: {
      "href": "#/chapter011"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("12. ")]), _c('a', {
    attrs: {
      "href": "#/chapter012"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("13. ")]), _c('a', {
    attrs: {
      "href": "#/chapter013"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("14. ")]), _c('a', {
    attrs: {
      "href": "#/chapter014"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("15. ")]), _c('a', {
    attrs: {
      "href": "#/chapter015"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("16. ")]), _c('a', {
    attrs: {
      "href": "#/chapter016"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("17. ")]), _c('a', {
    attrs: {
      "href": "#/chapter017"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("18. ")]), _c('a', {
    attrs: {
      "href": "#/chapter018"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("19. ")]), _c('a', {
    attrs: {
      "href": "#/chapter019"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("20. ")]), _c('a', {
    attrs: {
      "href": "#/chapter020"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("21. ")]), _c('a', {
    attrs: {
      "href": "#/chapter021"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("22. ")]), _c('a', {
    attrs: {
      "href": "#/chapter022"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("23. ")]), _c('a', {
    attrs: {
      "href": "#/chapter023"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("24. ")]), _c('a', {
    attrs: {
      "href": "#/chapter024"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("25. ")]), _c('a', {
    attrs: {
      "href": "#/chapter025"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("26. ")]), _c('a', {
    attrs: {
      "href": "#/chapter026"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("27. ")]), _c('a', {
    attrs: {
      "href": "#/chapter027"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("28. ")]), _c('a', {
    attrs: {
      "href": "#/chapter028"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("29. ")]), _c('a', {
    attrs: {
      "href": "#/chapter029"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("30. ")]), _c('a', {
    attrs: {
      "href": "#/chapter030"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("31. ")]), _c('a', {
    attrs: {
      "href": "#/chapter031"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("32. ")]), _c('a', {
    attrs: {
      "href": "#/chapter032"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("33. ")]), _c('a', {
    attrs: {
      "href": "#/chapter033"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("34. ")]), _c('a', {
    attrs: {
      "href": "#/chapter034"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("35. ")]), _c('a', {
    attrs: {
      "href": "#/chapter035"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("36. ")]), _c('a', {
    attrs: {
      "href": "#/chapter036"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("37. ")]), _c('a', {
    attrs: {
      "href": "#/chapter037"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("38. ")]), _c('a', {
    attrs: {
      "href": "#/chapter038"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("39. ")]), _c('a', {
    attrs: {
      "href": "#/chapter039"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("40. ")]), _c('a', {
    attrs: {
      "href": "#/chapter040"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("41. ")]), _c('a', {
    attrs: {
      "href": "#/chapter041"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("42. ")]), _c('a', {
    attrs: {
      "href": "#/chapter042"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("43. ")]), _c('a', {
    attrs: {
      "href": "#/chapter043"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("44. ")]), _c('a', {
    attrs: {
      "href": "#/chapter044"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("45. ")]), _c('a', {
    attrs: {
      "href": "#/chapter045"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("46. ")]), _c('a', {
    attrs: {
      "href": "#/chapter046"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("47. ")]), _c('a', {
    attrs: {
      "href": "#/chapter047"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("48. ")]), _c('a', {
    attrs: {
      "href": "#/chapter048"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("49. ")]), _c('a', {
    attrs: {
      "href": "#/chapter049"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("50. ")]), _c('a', {
    attrs: {
      "href": "#/chapter050"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("51. ")]), _c('a', {
    attrs: {
      "href": "#/chapter051"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("52. ")]), _c('a', {
    attrs: {
      "href": "#/chapter052"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("53. ")]), _c('a', {
    attrs: {
      "href": "#/chapter053"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("54. ")]), _c('a', {
    attrs: {
      "href": "#/chapter054"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("55. ")]), _c('a', {
    attrs: {
      "href": "#/chapter055"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("56. ")]), _c('a', {
    attrs: {
      "href": "#/chapter056"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("57. ")]), _c('a', {
    attrs: {
      "href": "#/chapter057"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("58. ")]), _c('a', {
    attrs: {
      "href": "#/chapter058"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("59. ")]), _c('a', {
    attrs: {
      "href": "#/chapter059"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("60. ")]), _c('a', {
    attrs: {
      "href": "#/chapter060"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("61. ")]), _c('a', {
    attrs: {
      "href": "#/chapter061"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("62. ")]), _c('a', {
    attrs: {
      "href": "#/chapter062"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("63. ")]), _c('a', {
    attrs: {
      "href": "#/chapter063"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Martina")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("64. ")]), _c('a', {
    attrs: {
      "href": "#/chapter064"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("65. ")]), _c('a', {
    attrs: {
      "href": "#/chapter065"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("66. ")]), _c('a', {
    attrs: {
      "href": "#/chapter066"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Irena")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("67. ")]), _c('a', {
    attrs: {
      "href": "#/chapter067"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("68. ")]), _c('a', {
    attrs: {
      "href": "#/chapter068"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("69. ")]), _c('a', {
    attrs: {
      "href": "#/chapter069"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("70. ")]), _c('a', {
    attrs: {
      "href": "#/chapter070"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Carlo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("71. ")]), _c('a', {
    attrs: {
      "href": "#/chapter071"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Sonia")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/alsobykatharinejohnson"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Also by Katharine Johnson")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/youwillalsoenjoy"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("You will also enjoy:")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/newslettersignup2"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Newsletter sign-up")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/anotefromthepublisher"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A note from the publisher")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 63
// module chunks = 0